import React from 'react';
import closeAspas from '../../assets/close-aspas.png';
import openAspas from '../../assets/open-aspas.png';
import {
  CloseAspas,
  ContainerDepoiment,
  ContainerDepoimentDesc,
  ContainerDepoimentDescTxt,
  ContainerDepoimentFooter,
  ContainerDepoimentFooterInfo,
  ContainerDepoimentFooterPagination,
  OpenAspas,
} from './style';

function Depoiment({ desc, id, lengthList, name, city }) {
  return (
    <ContainerDepoiment>
      <ContainerDepoimentDesc>
        <ContainerDepoimentDescTxt>
          <OpenAspas>
            <img src={openAspas} alt="depoimentos" />
          </OpenAspas>
          <p>{desc}</p>
          <CloseAspas>
            <img src={closeAspas} alt="depoimentos" />
          </CloseAspas>
        </ContainerDepoimentDescTxt>

        <ContainerDepoimentFooter>
          <ContainerDepoimentFooterPagination>
            <p>
              {id}/{lengthList}
            </p>
          </ContainerDepoimentFooterPagination>

          <ContainerDepoimentFooterInfo>
            <strong>{name}</strong>
            <p>{city}</p>
          </ContainerDepoimentFooterInfo>
        </ContainerDepoimentFooter>
      </ContainerDepoimentDesc>
    </ContainerDepoiment>
  );
}

export default Depoiment;
